import React, { JSX } from "react";
import { Outlet } from "react-router-dom";
import { Layout } from 'antd';

const { Content } = Layout;

const MainLayout: React.FC<{ Header: JSX.Element, Footer: JSX.Element}> = ({ Header, Footer }) => {

  return (
    <Layout>
      {Header}
      <Content>
        <Outlet/>
      </Content>
      {Footer} 
    </Layout>
  )
};

export default MainLayout;